import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {bounceUp, bounceDown} from '../../styles/keyframes/keyframes';

export const Toggle = styled.div`
  display: none;
  ${media.small`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  `};
`;

export const Cart = styled.i`
  width: ${props => props.theme.sideBasket.toggle.size};
  height: ${props => props.theme.sideBasket.toggle.cartSize};
  display: flex;
  align-items: flex-end;
  &:hover {
    &::before,
    &::after {
      transition: color 0.5s ease;
      color: ${props => props.theme.secondaryColor};
    }
  }
  &::after {
    font-family: 'icomoon';
    content: '\\f07a';
    font-size: ${props => props.theme.sideBasket.toggle.cartSize};
    color: ${props => props.theme.primaryColor};
    font-style: normal;
  }
`;

export const Arrow = styled.span`
  height: ${props => props.theme.sideBasket.toggle.cartSize};
  transition: color 0.5s ease-in-out;
  &::before {
    display: inline-block;
    font-family: 'icomoon';
    font-size: ${props => props.theme.sideBasket.toggle.arrowSize};
    color: ${props => props.theme.primaryColor};
    font-style: normal;
    margin-right: 0.6rem;
  }
`;

export const ArrowUp = Arrow.extend`
  &::before {
    content: '\\f077';
    animation: ${bounceUp} 3s linear infinite;
  }
`;

export const ArrowDown = Arrow.extend`
  &::before {
    content: '\\f078';
    animation: ${bounceDown} 3s linear infinite;
  }
`;



// WEBPACK FOOTER //
// ./components/BasketBar/ToggleButton.style.js